<script>
import config from '../config.js'
import analytics from '../utils/analytics.js'

import SidebarTab from '../components/SidebarTab.svelte'
import Icon from '../components/Icon.svelte'

import { settings } from '../stores.js'
import lightOnIcon from '../assets/icon/lightbulb-on.svg'
import lightOffIcon from '../assets/icon/lightbulb-off.svg'
import atIcon from '../assets/icon/cil-at.svg'
import questionIcon from '../assets/icon/help-circle.svg'
import searchIcon from '../assets/icon/cil-search.svg'
import giftIcon from '../assets/icon/cil-gift.svg'
import SearchTab from '../components/SearchTab.svelte'
import ContactTab from '../components/ContactTab.svelte'

import { sidebarToggle, overlay } from '../stores.js'

function toggleTab (tab) {
  if ($sidebarToggle) analytics.trackEvent('sidebar', $sidebarToggle, 'close')
  if ($sidebarToggle === tab) {
    sidebarToggle.set(null)
  } else {
    analytics.trackEvent('sidebar', tab, 'open')
    sidebarToggle.set(tab)
  }
}

function openOverlay (name) {
  sidebarToggle.set(null)
  analytics.trackEvent('overlay', name, 'open')
  $overlay = name
}

function toggleDarkMode () {
  $settings.darkMode = !$settings.darkMode
  analytics.trackEvent('darkMode', $settings.darkMode ? 'on' : 'off')
}
</script>

<style type="text/scss">
  .sidebar {
    position: fixed;
    top: 100px;
    left: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 150;

    .mobile-only {
      display: none;
    }

    @media screen and (max-width: 900px), screen and (max-height: 800px) {
      .mobile-only {
        display: block;
      }
    }
  }
</style>

<div class="sidebar">
  <SidebarTab open={$sidebarToggle === 'settings'} on:click={toggleDarkMode} tooltip="Dark Mode">
    <span slot="tab">
      <Icon icon={$settings.darkMode ? lightOffIcon : lightOnIcon} color="var(--light-a)" />
    </span>
  </SidebarTab>
  <SidebarTab open={$sidebarToggle === 'about'} on:click={() => {openOverlay('about')}} tooltip="FAQ">
    <span slot="tab">
      <Icon icon={questionIcon} color="var(--light-a)" />
    </span>
  </SidebarTab>
  <div class="mobile-only">
    <SidebarTab open={$sidebarToggle === 'search'} on:click={() => {toggleTab('search')}} tooltip="Search">
      <span slot="tab">
        <Icon icon={searchIcon} color="var(--light-a)" />
      </span>
      <div slot="content">
        <SearchTab />
      </div>
    </SidebarTab>
  </div>
  <SidebarTab open={$sidebarToggle === 'contact'} on:click={() => {toggleTab('contact')}} tooltip="Contact">
    <span slot="tab">
      <Icon icon={atIcon} color="var(--light-a)" />
    </span>
    <div slot="content">
      <ContactTab />
    </div>
  </SidebarTab>
  {#if config.donationsEnabled }
    <SidebarTab on:click={() => openOverlay('donation')} tooltip="Donate">
      <span slot="tab">
        <Icon icon={giftIcon} color="var(--light-a)" />
      </span>
    </SidebarTab>
  {/if}
</div>
